import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { getSandboxQueryOptions } from '@/lib/queries/loop-planner/useGetSandbox';
import { isHttpError } from '@/lib/utils/common/isHttpError';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/')({
  loader: async ({ params: { loopId, org }, context: { queryClient } }) => {
    try {
      await queryClient.ensureQueryData(getSandboxQueryOptions({ loopId: Number(loopId) }));
      throw redirect({
        to: '/org/$org/loop/$loopId/planner/sandbox/table',
        params: { org, loopId },
      });
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner/live/table',
          params: { org, loopId },
        });
      }
      throw error;
    }
  },
});
